import axios from "axios";
import React, { useState, useEffect } from "react";
import Cookies from "universal-cookie";
import DequipoRehabilitacion from "../../EliminaEquipos/DequipoRehabilitacion";
import CreaEquipoRehabilitacion from "./CreaEquipos/CreaEquipoRehabilitacion";

function EquipoRehabilitacion({ idSolicitud }) {
  const cookies = new Cookies();
  const [list, setList] = useState([]);

  // Función para obtener la lista
  const fetchList = () => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: `https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoRehabilitacionPorSolicitudId?SolicitudId=${idSolicitud}`,
    })
      .then((res) => setList(res.data))
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchList();
  }, []);

  const nombreRuta =
    window.location.href.split("/")[
      window.location.href.split("/").indexOf("#") + 1
    ];
  const handleDelete = (id) => {
    setList((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <div className="test container text-center">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">
            Equipo primario de Mejoramiento de servicios de rehabilitación
          </h6>
        </div>
        <div className="card-body">
          {cookies.get("tipo_Usuario") == 2 &&
            nombreRuta == "ProcesoAutoevaluacion" && (
              <CreaEquipoRehabilitacion
                idSolicitud={idSolicitud}
                onCreated={fetchList}
              />
            )}

          <div className="table-responsive">
            <table
              className="table table-bordered"
              width="100%"
              cellSpacing="0"
            >
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Nombre</th>
                  <th>Servicio</th>
                  <th>Cargo</th>
                  <th>Lider</th>
                  {cookies.get("tipo_Usuario") == 2 &&
                    nombreRuta === "ProcesoAutoevaluacion" && <th>Elimina</th>}
                </tr>
              </thead>
              <tbody>
                {list.map((item) => (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.nombre}</td>
                    <td>{item.servicio}</td>
                    <td>{item.cargo}</td>
                    <td>{item.lider}</td>
                    {cookies.get("tipo_Usuario") == 2 &&
                      nombreRuta === "ProcesoAutoevaluacion" && (
                        <td>
                          <DequipoRehabilitacion
                            id={item.id}
                            onDelete={handleDelete}
                          />
                        </td>
                      )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EquipoRehabilitacion;
